import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ChevronUp } from 'lucide-react';

const Footer = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  const handleScroll = useCallback(() => {
    setShowScrollTop(window.scrollY > 300);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#2c3540] text-white relative">
      {/* Main Footer Content - 2 Columns */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Left Column - Bilgi Merkezi */}
          <div className="border-r-0 md:border-r border-slate-600 pr-0 md:pr-12">
            <h4 className="text-white font-light mb-6 text-lg">Bilgi Merkezi</h4>
            <ul className="space-y-3">
              <li><Link to="/yasal-uyarilar" className="text-slate-400 hover:text-orange-400 transition-colors text-sm font-light">Yasal Uyarılar</Link></li>
              <li><Link to="/duyurular" className="text-slate-400 hover:text-orange-400 transition-colors text-sm font-light">Duyurular</Link></li>
              <li><Link to="/sikca-sorulan-sorular" className="text-slate-400 hover:text-orange-400 transition-colors text-sm font-light">Sıkça Sorulan Sorular</Link></li>
              <li><Link to="/hakkimizda/istiraklerimiz" className="text-slate-400 hover:text-orange-400 transition-colors text-sm font-light">İştiraklerimiz ve Grup Şirketlerimiz</Link></li>
            </ul>
          </div>

          {/* Right Column - İletişim */}
          <div className="pl-0 md:pl-12">
            <h4 className="text-white font-light mb-6 text-lg">İletişim</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-slate-400 mt-1 flex-shrink-0" />
                <div className="text-slate-400 text-sm font-light">
                  <p>Esentepe Mah. Ali Kaya Sk. Pol Center A</p>
                  <p>Blok No: 1 İç Kapı: 62 Şişli/İstanbul</p>
                </div>
              </li>
              <li>
                <h5 className="text-white font-light mb-2 text-sm">Şubeler</h5>
                <a href="mailto:musterimemnuniyeti@tmdonlinesube.com" className="text-slate-400 hover:text-orange-400 transition-colors text-sm font-light break-all block">
                  musterimemnuniyeti@tmdonlinesube.com
                </a>
              </li>
            </ul>
            
            {/* Social Media Icons */}
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-slate-400 hover:text-orange-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm3.066 8.235c.015.174.015.348.015.522 0 5.304-4.037 11.417-11.417 11.417-2.27 0-4.378-.664-6.153-1.803.322.038.63.053.965.053 1.856 0 3.564-.63 4.923-1.69-1.74-.03-3.203-1.18-3.71-2.754.606.098 1.16.098 1.784-.03-1.817-.367-3.173-1.97-3.173-3.897v-.053c.53.295 1.144.475 1.794.498-1.066-.712-1.767-1.926-1.767-3.305 0-.735.197-1.415.538-2.002 1.956 2.402 4.878 3.977 8.168 4.14-.068-.295-.106-.598-.106-.902 0-2.188 1.773-3.961 3.961-3.961 1.144 0 2.175.482 2.898 1.25.902-.174 1.75-.5 2.513-.952-.295.927-.927 1.704-1.75 2.19.803-.09 1.576-.307 2.292-.62-.53.795-1.204 1.495-1.98 2.055z"/></svg>
              </a>
              <a href="#" className="text-slate-400 hover:text-orange-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
              <a href="#" className="text-slate-400 hover:text-orange-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a href="#" className="text-slate-400 hover:text-orange-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
              </a>
              <a href="#" className="text-slate-400 hover:text-orange-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Disclaimer Section */}
      <div className="border-t border-slate-700 py-8 bg-[#2a3138]">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto text-center">
            <p className="text-slate-400 text-xs leading-relaxed mb-6">
              Sermaye Piyasası Kurumları, Yatırım Hizmetleri ve Faaliyetleri ile Yan Hizmetler İlgili Esaslar Hakkında Tebliğ Uyarınca Yayınlanan Uyarı Notu - "Burada yer alan yatırım bilgi, yorum ve tavsiyeler yatırım danışmanlığı kapsamında değildir. Yatırım danışmanlığı hizmeti; yetkili kuruluşlarca kişilerin finansal durumları, risk ve getiri tercihleri dikkate alınarak kişiye özel sunulmaktadır. Burada yer alan yorum ve tavsiyeler ise genel niteliktedir. Bu tavsiyeler mali durumunuza uygun olmayabilir. Bu nedenle, sadece burada yer alan bilgilere dayanılarak yatırım kararı verilmesi beklentilerinize uygun sonuçlar doğurmayabilir. Ayrıca, sadece burada yer alan bilgilere dayanılarak yapılan yatırım kararı verilmesi beklentilerinize uygun sonuçlar doğurmayabilir."
            </p>
            <p className="text-slate-500 text-xs">
              Copyright © 2026 <span className="text-orange-500 font-medium">Turkish Menkul Değerler</span> | Tüm Hakları Saklıdır.
            </p>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-14 h-14 rounded-full bg-white shadow-xl hover:shadow-2xl transition-all flex items-center justify-center z-50 group"
        >
          <ChevronUp className="w-6 h-6 text-orange-500 group-hover:text-orange-600" />
        </button>
      )}
    </footer>
  );
};

export default Footer;
